import React from "react";
import PropTypes from "prop-types";
import NotificationItem from "./NotificationItem";
import { useTranslation } from "react-i18next";

const NotificationList = ({ notifications, isLoading, error, onNotificationClick, onMarkAllRead }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <>
        <div className="notification-header">
          <h3>{t("notifications.title", "Notifications")}</h3>
        </div>
        <div className="notification-empty">
          {t("notifications.loading", "Loading...")}
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <div className="notification-header">
          <h3>{t("notifications.title", "Notifications")}</h3>
        </div>
        <div className="notification-empty">
          {t("notifications.error", "Could not load notifications")}
        </div>
      </>
    );
  }

  if (!notifications || notifications.length === 0) {
    return (
      <div className="notification-empty">
        {t("notifications.empty", "No notifications")}
      </div>
    );
  }

  return (
    <>
      <div className="notification-header">
        <h3>{t("notifications.title", "Notifications")}</h3>
        <button className="mark-all-read" onClick={onMarkAllRead}>
          {t("notifications.markAllRead", "Mark all as read")}
        </button>
      </div>
      <ul className="notification-list">
        {notifications.map((notification) => (
          <NotificationItem
            key={notification._id}
            notification={notification}
            onClick={onNotificationClick}
          />
        ))}
      </ul>
      <div className="notification-footer">
        <button className="view-all-btn">
          {t("notifications.viewAll", "View all notifications")}
        </button>
      </div>
    </>
  );
};

NotificationList.propTypes = {
  notifications: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.any,
  onNotificationClick: PropTypes.func.isRequired,
  onMarkAllRead: PropTypes.func.isRequired,
};

export default NotificationList;
